// Mock data for Trump of the Lord Ministries

export const books = [
  {
    id: 'a1',
    title: "The King's Return: Little Book 2 (Laymen's Edition)",
    price: 14.99,
    category: 'books',
    description: 'A post-tribulational eschatological introduction applying plain grammar to biblical prophecy.',
    image: 'https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    format: 'Print (POD)',
    pages: 280
  },
  {
    id: 'a2',
    title: 'GIT Curriculum Workbook',
    price: 24.99,
    category: 'books',
    description: 'Interactive curriculum applying the Grammar Integrity Test to key prophetic passages.',
    image: 'https://images.unsplash.com/photo-1497621122273-f5cfb6065c56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    format: 'Print (POD)',
    pages: 320
  },
  {
    id: 'a3',
    title: '16 Lesson Booklet Set',
    price: 39.99,
    category: 'books',
    description: 'Complete 16-lesson series for small group or individual study.',
    image: 'https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    format: 'Print (POD)',
    pages: '16 booklets'
  },
  {
    id: 'b1',
    title: 'The Grammar of His Coming (Manuscript)',
    price: 34.99,
    category: 'books',
    description: 'Scholarly manuscript with comprehensive grammatical analysis of eschatological passages.',
    image: 'https://images.unsplash.com/photo-1497621122273-f5cfb6065c56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    format: 'Print (POD)',
    pages: 450
  },
  {
    id: 'b2',
    title: 'Appendices Volume 1',
    price: 29.99,
    category: 'books',
    description: 'Detailed appendices examining corner pieces and border pieces of the prophetic puzzle.',
    image: 'https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    format: 'Print (POD)',
    pages: 380
  },
  {
    id: 'voice1',
    title: 'The Voice of the Spirit - Book 1',
    price: 19.99,
    category: 'books',
    description: 'A companion work exploring the ministry of the Holy Spirit in these last days.',
    image: 'https://images.unsplash.com/photo-1497621122273-f5cfb6065c56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    format: 'Print (POD)',
    pages: 290
  }
];

export const shofars = [
  {
    id: 'sh1',
    title: "Beginner's Ram Horn Shofar",
    price: 45.00,
    category: 'shofars',
    description: 'Natural ram horn, perfect for beginners learning the four biblical calls.',
    image: 'https://images.unsplash.com/photo-1658343546442-85e82a8d5186?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxyYW0lMjBob3JufGVufDB8fHx8MTc3MzUzNTgxNHww&ixlib=rb-4.1.0&q=85',
    size: '12-14 inches'
  },
  {
    id: 'sh2',
    title: 'Half-Polished Ram Horn',
    price: 95.00,
    category: 'shofars',
    description: 'Beautiful half-polished finish with rich tone quality.',
    image: 'https://images.unsplash.com/photo-1603241286521-2227e504e37d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxyYW0lMjBob3JufGVufDB8fHx8MTc3MzUzNTgxNHww&ixlib=rb-4.1.0&q=85',
    size: '14-16 inches'
  },
  {
    id: 'sh3',
    title: 'Full-Polished Ram Horn Shofar',
    price: 165.00,
    category: 'shofars',
    description: 'Premium polished shofar with exceptional clarity and resonance.',
    image: 'https://images.unsplash.com/photo-1658343546442-85e82a8d5186?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxyYW0lMjBob3JufGVufDB8fHx8MTc3MzUzNTgxNHww&ixlib=rb-4.1.0&q=85',
    size: '16-20 inches'
  },
  {
    id: 'sh4',
    title: 'Kudu Shofar',
    price: 250.00,
    category: 'shofars',
    description: 'Majestic spiral kudu horn with powerful, deep tones.',
    image: 'https://images.unsplash.com/photo-1603241286521-2227e504e37d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxyYW0lMjBob3JufGVufDB8fHx8MTc3MzUzNTgxNHww&ixlib=rb-4.1.0&q=85',
    size: '24-30 inches'
  },
  {
    id: 'sh5',
    title: 'Shofar Care Kit',
    price: 35.00,
    category: 'shofars',
    description: 'Complete care kit with anointing oil, carrying bag, and cleaning cloth.',
    image: 'https://images.unsplash.com/photo-1636396279298-021f7ec515e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxmcmFua2luY2Vuc2V8ZW58MHx8fHwxNzczNTM1ODIwfDA&ixlib=rb-4.1.0&q=85'
  }
];

export const apothecary = [
  {
    id: 'ap1',
    title: 'Frankincense & Myrrh Set',
    price: 29.99,
    category: 'apothecary',
    description: 'Pure frankincense and myrrh resin from biblical lands. Used in worship and prayer.',
    image: 'https://images.unsplash.com/photo-1636396279298-021f7ec515e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxmcmFua2luY2Vuc2V8ZW58MHx8fHwxNzczNTM1ODIwfDA&ixlib=rb-4.1.0&q=85',
    scripture: 'Exodus 30:34-36'
  },
  {
    id: 'ap2',
    title: 'Anointing Oil - Exodus Blend',
    price: 24.99,
    category: 'apothecary',
    description: 'Sacred anointing oil crafted according to the biblical formula.',
    image: 'https://images.unsplash.com/photo-1673551389008-98e0fcb7f263?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxmcmFua2luY2Vuc2V8ZW58MHx8fHwxNzczNTM1ODIwfDA&ixlib=rb-4.1.0&q=85',
    scripture: 'Exodus 30:22-25'
  },
  {
    id: 'ap3',
    title: 'Hyssop Purification Bundle',
    price: 18.99,
    category: 'apothecary',
    description: 'Dried hyssop branches for spiritual cleansing and purification rituals.',
    image: 'https://images.unsplash.com/photo-1636396279298-021f7ec515e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxmcmFua2luY2Vuc2V8ZW58MHx8fHwxNzczNTM1ODIwfDA&ixlib=rb-4.1.0&q=85',
    scripture: 'Psalm 51:7'
  },
  {
    id: 'ap4',
    title: 'Ancient Remedy Collection',
    price: 44.99,
    category: 'apothecary',
    description: 'Curated collection of biblical herbs: cedarwood, frankincense, hyssop, and spikenard.',
    image: 'https://images.unsplash.com/photo-1673551389008-98e0fcb7f263?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxmcmFua2luY2Vuc2V8ZW58MHx8fHwxNzczNTM1ODIwfDA&ixlib=rb-4.1.0&q=85',
    scripture: 'Multiple references'
  }
];

export const bundles = [
  {
    id: 'bundle1',
    title: 'Starter Bundle',
    price: 24.99,
    originalPrice: 34.98,
    savings: 9.99,
    category: 'bundles',
    description: "Little Book 2 + GIT Lesson 1 booklet. Includes 30-day Berean digital trial.",
    image: 'https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    includes: ['Little Book 2', 'GIT Lesson 1', '30-day Berean access'],
    badge: 'Best Value'
  },
  {
    id: 'bundle2',
    title: 'Scholar Library',
    price: 109.99,
    originalPrice: 152.95,
    savings: 42.96,
    category: 'bundles',
    description: '5-volume scholarly collection. Includes 12-month Scholar subscription free.',
    image: 'https://images.unsplash.com/photo-1497621122273-f5cfb6065c56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    includes: ['Grammar Manuscript', 'Appendices Vol. 1 & 2', 'Scholar Curriculum', 'GIT Lesson 1', '12-month Scholar access'],
    badge: 'Most Popular'
  },
  {
    id: 'bundle3',
    title: 'Complete Library',
    price: 149.99,
    originalPrice: 209.93,
    savings: 59.94,
    category: 'bundles',
    description: 'All 8 volumes + 12-month Scholar + 20% lifetime discount on future releases.',
    image: 'https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    includes: ['All 8 books', '12-month Scholar', '20% lifetime discount', 'Ministry Reader Roll listing'],
    badge: 'Complete Collection'
  },
  {
    id: 'bundle4',
    title: 'Church Group Kit',
    price: 299.99,
    originalPrice: 449.90,
    savings: 149.91,
    category: 'bundles',
    description: '10-person church curriculum. Includes 12-month Church tier (25 digital seats).',
    image: 'https://images.unsplash.com/photo-1497621122273-f5cfb6065c56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxvcGVuJTIwYmlibGV8ZW58MHx8fHwxNzczNTM1Nzk0fDA&ixlib=rb-4.1.0&q=85',
    includes: ['10x Little Book 2', '10x Curriculum Workbook', 'Leader Guide', '12-month Church tier', 'Facilitator dashboard'],
    badge: 'Churches'
  }
];

export const subscriptionTiers = [
  {
    id: 'seeker',
    name: 'Seeker',
    price: 0,
    period: 'Free',
    description: 'Start your journey into post-tribulational truth',
    features: [
      'Little Book 2 web reader',
      'Mind map overview (read-only)',
      '3 GIT investigations per month',
      'Store access',
      'Newsletter'
    ],
    buttonText: 'Start Free',
    popular: false
  },
  {
    id: 'berean',
    name: 'Berean',
    price: 9,
    period: 'per month',
    yearlyPrice: 79,
    description: 'Full interactive access to all teaching materials',
    features: [
      'Full interactive ebook with live appendix links',
      'Unlimited GIT investigations',
      'Full interactive mind map',
      'Highlights & notes sync',
      '10% store discount',
      '30-day trial with any book purchase'
    ],
    buttonText: 'Start 30-Day Trial',
    popular: true
  },
  {
    id: 'scholar',
    name: 'Scholar',
    price: 19,
    period: 'per month',
    yearlyPrice: 159,
    description: 'Deep dive into scholarly research and curriculum',
    features: [
      'Everything in Berean',
      'Full 16-lesson curriculum',
      'Comparative Doctrine Investigator',
      'Scholarly manuscript access',
      'Early appendix access',
      '15% store discount + free digital with physical',
      'Monthly Q&A with Mordecai'
    ],
    buttonText: 'Upgrade to Scholar',
    popular: false
  },
  {
    id: 'church',
    name: 'Pastor/Church',
    price: 49,
    period: 'per month',
    yearlyPrice: 399,
    description: 'Complete solution for teaching congregations',
    features: [
      'Scholar access for leader',
      '25 Berean seats for congregation',
      'Group reading room',
      'Facilitator dashboard',
      'Licensed printable curriculum',
      '20% bulk discount',
      'Free 12 months with Church Kit purchase'
    ],
    buttonText: 'Contact for Church Access',
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Pastor James Wilson',
    role: 'Senior Pastor, Grace Community Church',
    content: 'The Grammar Integrity Test changed everything. For years we taught pre-trib rapture, but when we actually examined the grammar of the passages, the post-trib position became undeniable. Our entire church has been transformed by this teaching.',
    rating: 5
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'Bible Study Leader',
    content: "I've studied eschatology for 20 years, but Mordecai's plain grammatical approach cut through all the speculation and showed me what the text actually says. The interactive ebook with live appendix links makes deep study accessible.",
    rating: 5
  },
  {
    id: 3,
    name: 'Dr. Michael Thornton',
    role: 'Seminary Professor',
    content: 'The scholarly manuscript demonstrates rigorous exegetical methodology. The six-protocol GIT system provides a replicable framework for evaluating any eschatological claim against the actual grammar of Scripture.',
    rating: 5
  }
];
